import React, { useState, useEffect, useRef, useCallback } from 'react';
import moment from 'moment-timezone';
import './index.scss';
import * as API from '../../configuration/apiconfig';
import MovieCard from '../MovieCard';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import { keyboardLayout } from '../../utils/keyBoardLayout';

const getMonthInNumber = monthInString => {
  var monthNameArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var monthNumber = monthNameArray.indexOf(monthInString) + 1;
  return monthNumber < 10 ? '0' + monthNumber : monthNumber;
};
const getMonthDays = (getShowDate, getFields) => {
  if (getFields === 'monthField') {
    var getMonth = getShowDate.split('T')[0].split('-')[1];
    var monthNameArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    return monthNameArray[getMonth - 1];
  } else if (getFields === 'dayField') {
    var dayName = new Date(getShowDate);
    var weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return weekday[dayName.getDay()];
  }
};

const getTodayDate = tz => {
  var currentDates = moment().tz(tz);
  currentDates = currentDates.format().split('T')[0];
  var currentDateArr = currentDates.split('-');
  var date = currentDateArr[0] + '-' + currentDateArr[1] + '-' + currentDateArr[2];
  return date;
};

const populateDataString = (showDateItem, dayName) => {
  var showDate = showDateItem.split('T')[0];
  var currentDates = new Date().toString().split(' ');
  var currentDateString = currentDates[3] + '-' + getMonthInNumber(currentDates[1]) + '-' + currentDates[2];
  var dayStr = getMonthDays(showDateItem, 'monthField') + ' ' + showDateItem.split('T')[0].split('-')[2];
  return (
    <>
      <div className="movie-date">{showDate === currentDateString ? 'Today' : dayStr}</div>
      <div className="movie-day">{dayName.slice(0, 3)}</div>
    </>
  );
};

const DateSelection = ({ selectedDate, onSelectDate, distinctShowDates }) => {
  return (
    <div className="date-selection-container">
      <ul id="date-list">
        {distinctShowDates &&
          distinctShowDates.map(showDate => {
            const currentShowDate = showDate.showdate.split('T')[0];
            return (
              <li key={showDate.showdate} onClick={() => onSelectDate(currentShowDate)} className={`movie-date-wrap ${currentShowDate === selectedDate ? 'today' : ''}`}>
                {populateDataString(showDate.showdate, showDate.day)}
              </li>
            );
          })}
      </ul>
    </div>
  );
};

const FilmSelection = ({ films, filmsOnSelectedDate, handleFilmSelection, selectedFilm, isLoadingShowtimes }) => {
  return (
    <div style={{ overflowX: 'auto', display: 'flex', gap: '30px', paddingBottom: '12px' }}>
      {films?.length > 0 || isLoadingShowtimes ? (
        <>
          {films.map((film, index) => {
            if (filmsOnSelectedDate.includes(film.id)) {
              return <MovieCard key={film.id} film={film} filmIndex={index} handleMovieClick={handleFilmSelection} selectedFilm={selectedFilm} />;
            }
            return null;
          })}
        </>
      ) : (
        <>
          <SkeletonTheme baseColor="#d6d6d6" highlightColor="#ccc">
            <div className="movie-skeletons p-0" style={{ display: 'flex', gap: '12px' }}>
              <div style={{ flexShrink: 0 }}>
                <Skeleton height="484px" width="230px" />
              </div>
              <div style={{ flexShrink: 0 }}>
                <Skeleton height="484px" width="230px" />
              </div>
              <div style={{ flexShrink: 0 }}>
                <Skeleton height="484px" width="230px" />
              </div>
              <div style={{ flexShrink: 0 }}>
                <Skeleton height="484px" width="230px" />
              </div>
            </div>
          </SkeletonTheme>
        </>
      )}
    </div>
  );
};

const ShowTimeSelection = ({ selectFilmShowtimes, experienceData, handleShowTimeSelection, selectedShowtime }) => {
  const formatShowTime = time => {
    if (!time) return '';
    const actualShowTime = time.split('T')[1]?.split(':') || [];
    let hours = Number(actualShowTime[0]);
    if (Number.isNaN(hours)) return time;
    hours = hours > 12 ? hours - 12 : hours;
    hours = `0${hours}`.slice(-2);

    let minutes = actualShowTime[1] || '00';
    minutes = `0${minutes}`.slice(-2);

    const meridian = Number(actualShowTime[0]) >= 12 ? 'PM' : 'AM';
    return `${hours}:${minutes} ${meridian}`;
  };

  const getShowtimeClass = ticketStatus => {
    if (ticketStatus === 'Available') return 'showtimeAvailable';
    if (ticketStatus === 'Fast Filling') return 'showtimeFastFilling';
    if (ticketStatus === 'Sold Out') return 'showtimeSold';
    if (ticketStatus === 'Disabled') return 'showtimeDisabled';
    return '';
  };
  if (!selectFilmShowtimes || selectFilmShowtimes.length === 0) {
    return (
      <aside className="showtime-not">
        <p>Showtimes are coming soon! Tickets for this film are not yet available.</p>
      </aside>
    );
  }

  const uniqueExperienceIds = [...new Set(selectFilmShowtimes.map(showtime => String(showtime.experiences?.[0])))].filter(Boolean);

  return (
    <div className="play-wrap-container">
      {uniqueExperienceIds.map(experienceId => {
        const experience = experienceData.find(exp => String(exp.id) === experienceId);
        const showtimesForExperience = selectFilmShowtimes.filter(showtime => String(showtime.experiences?.[0]) === experienceId);

        return (
          <section className="play-wrap" key={experienceId}>
            <div className="play-icon-wrap">
              <h2>{experience?.name || `Experience ${experienceId}`}</h2>
            </div>
            <div className="dates-container">
              {showtimesForExperience.map(showtime => {
                const ticketStatus = showtime.ticketstatus;
                const showtimeClass = getShowtimeClass(ticketStatus);

                return (
                  <button
                    type="button"
                    key={showtime.id}
                    className={`play-time play-date-wrap ${showtimeClass} ${showtime.id === selectedShowtime?.id ? 'is-selected' : ''}`}
                    onClick={() => handleShowTimeSelection(showtime)}
                  >
                    {formatShowTime(showtime.showtime)}
                    {(ticketStatus === 'Fast Filling' || ticketStatus === 'Sold Out') && <small style={{ display: 'block', marginTop: '4px', fontSize: '12px' }}>{ticketStatus}</small>}
                  </button>
                );
              })}
            </div>
          </section>
        );
      })}
    </div>
  );
};
const SeatSelection = ({ seatNumber, setSeatNumber }) => {
  const inputRef = useRef(null);
  const keyboardRef = useRef(null);
  const [layoutName, setLayoutName] = useState('shift');

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleKeyboardChange = input => {
    setSeatNumber(input);
  };

  const handleKeyboardKeyPress = button => {
    if (button === '{shift}' || button === '{lock}') {
      setLayoutName(prev => (prev === 'ip' ? 'shift' : 'ip'));
    }
  };

  return (
    <div className="seat-selection-container">
      <div className="input-wrap">
        <img src="/assets/images/in-seat-delivery.png" alt="" width={120} />
        <input ref={inputRef} id="seatNumber" type="text" placeholder="Enter Seat Number" autoComplete="off" value={seatNumber} readOnly />
      </div>
      <Keyboard
        keyboardRef={r => (keyboardRef.current = r)}
        layoutName={layoutName}
        onChange={handleKeyboardChange}
        onKeyPress={handleKeyboardKeyPress}
        layout={keyboardLayout}
        display={{
          '{bksp}': 'Backspace',
          '{enter}': 'Enter',
          '{shift}': 'Shift',
          '{lock}': 'Caps',
          '{tab}': 'Tab',
          '{space}': 'Space',
        }}
        // baseClass={"login-barcodescan-keyboard"}
        disableRowButtonContainers={true}
      />
    </div>
  );
};

const BookingSelection = ({ handleFnbSectionDisable, updateBookedTicketDetails, handleBookingSelection }) => {
  // TODO: Let the user add the ticket booking details that needs to be added to fnb standalone order.
  // Steps : 1) Let the user choose the date : call the endpoint that fetches the films on that date
  // 2) User selects the film and choose the showdate and showtime
  // 3) User enters the seat details
  // 4) Add all the booking details to the fnb order.
  const [cinemaId] = useState(localStorage.getItem('cinemaid'));
  const [selectedDate, setSelectedDate] = useState('');
  const [cinemaDetails, setCinemaDetails] = useState(null);
  const [films, setFilms] = useState([]);
  const [allFilmsShowtimes, setAllFilmsShowtimes] = useState([]);
  const [filmsOnSelectedDate, setFilmsOnSelectedDate] = useState([]);
  const [selectedFilm, setSelectedFilm] = useState(null);
  const [selectFilmShowtimes, setSelectedFilmShowtimes] = useState([]);
  const [experienceData, setExperienceData] = useState([]);
  const [selectedShowtime, setSelectedShowTime] = useState(null);
  const [seatNumber, setSeatNumber] = useState('');
  const [distinctShowDates, setDistinctShowDates] = useState([]);
  const [isLoadingShowtimes, setIsLoadingShowtimes] = useState(false);
  const [isLoadingShowDates, setIsLoadingShowDates] = useState(true);

  const canShowFilms = Boolean(selectedDate);
  const canShowShowtimes = Boolean(selectedDate && selectedFilm);
  const canShowSeat = Boolean(selectedDate && selectedFilm && selectedShowtime);
  const canContinue = Boolean(selectedDate && selectedFilm && selectedShowtime && seatNumber.trim().length > 0);

  useEffect(() => {
    API.callEndpoint('GET', 'Bearer', '/cms/v2/films')
      .then(res => setFilms(res.data || []))
      .catch(() => console.log('Error fetching films'));

    API.callEndpoint('GET', 'Bearer', '/cms/v2/cinemas')
      .then(res => {
        let cinemas = res.data || [];
        let cinemaDetailsTemp = cinemas.find(cinema => String(cinema.id) === String(cinemaId));
        setCinemaDetails(cinemaDetailsTemp);
        setSelectedDate(getTodayDate(cinemaDetailsTemp.tz));
      })
      .catch(() => console.log('Error fetching cinema details'));

    API.callEndpoint('GET', 'Bearer', '/cms/v2/experiences')
      .then(res => setExperienceData(res.data || []))
      .catch(() => console.log('Error fetching experiences'));

    API.callEndpoint('GET', 'Bearer', `/cms/v2/distinctshowdates?cinemaid=${cinemaId}`)
      .then(res => setDistinctShowDates(res.data || []))
      .catch(err => console.log(err, 'error fetching showdates'))
      .finally(() => setIsLoadingShowDates(false));
  }, [cinemaId]);

  const getFilmsOnShowdate = useCallback(
    showDate => {
      if (!showDate) {
        setAllFilmsShowtimes([]);
        setFilmsOnSelectedDate([]);
        return;
      }
      setIsLoadingShowtimes(true);
      API.callEndpoint('GET', 'Bearer', `/cms/v2/showtimes?showdate=${showDate}&cinemaid=${cinemaId}`)
        .then(res => {
          //console.log(res, 'res from getFilmsOnshowdate');
          const showtimes = res.data || [];
          setAllFilmsShowtimes(showtimes);
          let films = [];
          if (showtimes && Array.isArray(showtimes)) {
            showtimes.forEach(showtime => {
              if (!films.includes(showtime.filmid)) {
                films.push(showtime.filmid);
              }
            });
          }
          setFilmsOnSelectedDate(films);
        })
        .catch(err => {
          console.log('Error fetching films');
          setAllFilmsShowtimes([]);
          setFilmsOnSelectedDate([]);
        })
        .finally(() => setIsLoadingShowtimes(false));
    },
    [cinemaId]
  );

  useEffect(() => {
    getFilmsOnShowdate(selectedDate);
  }, [selectedDate, getFilmsOnShowdate]);

  const handleDateSelection = showDate => {
    setSelectedDate(showDate);
    setSelectedFilm(null);
    setSelectedFilmShowtimes([]);
    setSelectedShowTime(null);
    setSeatNumber('');
  };

  const handleFilmSelection = film => {
    let allShowtimes = allFilmsShowtimes;
    let selectedFilmShowtimesTemp = allShowtimes.filter(showtime => showtime.filmid === film.id && String(showtime.cinemaid) === String(cinemaId));
    setSelectedFilm(film);
    setSelectedFilmShowtimes(selectedFilmShowtimesTemp);
    setSelectedShowTime(null);
    setSeatNumber('');
  };

  const handleShowTimeSelection = showtime => {
    //console.log(showtime, 'handleShowTimeSelection');
    setSelectedShowTime(showtime);
    setSeatNumber('');
  };

  const handleContinue = () => {
    if (!canContinue) {
      return;
    }
    updateBookedTicketDetails(
      {
        sessionId: selectedShowtime.id,
        deliveryseat: seatNumber,
      },
      handleBookingSelection
    );
    // handleBookingSelection();
  };

  return (
    <div className="booking-selection-container">
      <section className="step-section">
        <h3 className="booking-selection-title">Select Movie</h3>
        {!canShowFilms ? (
          <p className="step-helper-text">Select a Showdate to view movies</p>
        ) : filmsOnSelectedDate.length === 0 ? (
          <p className="step-helper-text">No movies available for the selected date.</p>
        ) : (
          <FilmSelection films={films} filmsOnSelectedDate={filmsOnSelectedDate} handleFilmSelection={handleFilmSelection} selectedFilm={selectedFilm} isLoadingShowtimes={isLoadingShowtimes} />
        )}
      </section>

      <section className="step-section">
        <h3 className="booking-selection-title">Select Showtime</h3>
        {!canShowShowtimes ? (
          <p className="step-helper-text">Select a Showtime to view showtimes</p>
        ) : isLoadingShowtimes ? (
          <SkeletonTheme baseColor="#d6d6d6" highlightColor="#ccc">
            <div className="movie-skeletons p-0">
              <Skeleton count={3} height="90px" width="100%" />
            </div>
          </SkeletonTheme>
        ) : (
          <ShowTimeSelection selectFilmShowtimes={selectFilmShowtimes} experienceData={experienceData} handleShowTimeSelection={handleShowTimeSelection} selectedShowtime={selectedShowtime} />
        )}
      </section>

      <section className="step-section">
        <h3 className="booking-selection-title">Enter Seat Number</h3>
        {!canShowSeat ? <p className="step-helper-text">Select a Showtime</p> : <SeatSelection seatNumber={seatNumber} setSeatNumber={setSeatNumber} />}
      </section>

      <div className="footer">
        <button className="btn btnSecondary" onClick={handleContinue} disabled={!canContinue}>
          Continue
        </button>
      </div>
    </div>
  );
};

export default BookingSelection;
